import React from "react";

export const revistaVueloTitle = (
  <div>
    La revista <i>Vuelo</i>
  </div>
);

export const revistaVueloContent = (
  <div>
    <p className="content justified">
      Tanto le gustaba a Oswaldo Díaz Díaz el tema de la aviación, probablemente gracias a la influencia de su hermano
      Andrés María, que en la <em>Revista de las Indias</em> de 1941 se refieren a él como &nbsp; “Doctor en derecho y
      especialista en asuntos aeronáuticos. Ha ocupado el cargo de jefe de la aviación civil colombiana” .
    </p>
    <p className="content justified">Se sabe que contribuyó a redactar el código aeronáutico civil colombiano.</p>
    <p className="content justified">
      En 1937 dirigió la primera publicación de <em>Vuelo. Revista de divulgación aeronáutica colombiana.</em> Se
      editaron cuatro números durante su primera etapa.
    </p>
    <p className="content justified">
      El segundo volumen de <em>Vuelo</em> apareció en abril de 1938, prometiendo publicarse mensualmente para ser
      vendida por 10 centavos; esto con el fin de ser una revista “francamente popular”.
    </p>
  </div>
);
